var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',_vm._b({on:{"reset":_vm.reset,"submitForm":_vm.submitForm}},'crud-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }